<template>
 <Head>
    <title> Pending Expired Report | {{$page.props.appName}}</title>
    <meta name="description" :content="'Pending Expired ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
        <h1 class="text-2xl font-semibold ml-5">Pending Expired Report</h1>
         <p class="ml-5">Please select your filter options below in order to generate the report.</p>
          <form @submit.prevent="store">
          
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                <div class="pr-6 pb-8 w-full lg:w-1/2">
                <label for="text-input-21" class="form-label">Filter Tickets:</label>
                <select class="form-select" v-model="this.form.filter">
                   <option value="pending">PENDING</option>
                   <option value="expired">EXPIRED</option>

                </select>
              </div>
              
            
            </div>
          </form>

       <div class="w-full">
            <a :href="'/admin/reports/pendingexpiredtickets/excel?filter='+this.form.filter"><button type="submit" class="bg-black text-white font-bold p-2 ml-6 mt-3 float-left">GENERATE EXCEL SPREADSHEET </button></a>

            <button type="submit" class="bg-black text-white font-bold p-2 ml-6 mt-3 float-right" @click="store()" :disabled="form.processing">GENERATE REPORT </button>

          </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head },
  props: {
    announcements: Object
    },
  data() {
    return {
      form: this.$inertia.form({
        filter: 'pending'
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/reports/pendingexpiredtickets");

    }
   
  },
};
</script>
     